import React, { FC } from "react";

import {
  useSearchParams,
  useSetSearchParams,
} from "@Libs/Router/hooks/useSearchParams";
import { CSSIsolation } from "@UI/Contexts/CSSIsolation";
import { TaskCreationBlockedModal } from "@Shared/Components/TaskCreationBlockedModal/TaskCreationBlockedModal";

// Set by the Rails redirect that turns a soft-banned client away from the task
// creation pages (`TasksController#task_creation`).
const BLOCKED_PARAM = "cannot_create_task";

export const TaskCreationBlockedModalRoot: FC = () => {
  const setSearchParams = useSetSearchParams();
  const isOpen = useSearchParams(BLOCKED_PARAM) === "true";

  // Dropping the param closes the modal: a reload or a shared link must not
  // bring it back.
  const handleClose = () =>
    setSearchParams(
      (params) => {
        params.delete(BLOCKED_PARAM);
        return params;
      },
      { replace: true }
    );

  return (
    <CSSIsolation>
      <TaskCreationBlockedModal isOpen={isOpen} onClose={handleClose} />
    </CSSIsolation>
  );
};
